import React from 'react'
import _replace from 'lodash/replace'
import TooltipWrapper from './TooltipWrapper'
import FullOffer from './FullOffer'

export default class RentalTemplate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            fullOffer: false
        }
    }

    renderFreeOptionals = (optionals) => {
        let i = 1
        const result = optionals.map(o => {
            return (
                <span key={i++}> {o.name}</span>
            )
        })
        if (result.count === 0) return null
        result.unshift(this.props.t.free_optionals)
        return result
    }

    renderTooltip = (target, params = {}) => {
        let text = this.props.t[`${target}`]
        Object.keys(params).map(k => text = _replace(text, k, params[k]))
        return <i className="fa fa-info-circle text-primary ml-1" style={{fontSize: 16}} data-tip={text}/>
    }


    componentDidMount() {
        if (!(this.props.initialIndex && this.props.index && this.props.initialIndex === this.props.index)) return
        const el = document.getElementById(`anchor_${this.props.index}`)
        if (el) {
            el.scrollIntoView()
            this.props.resetIndex && this.props.resetIndex()
        }
    }

    render() {
        const offer = this.props.offer || {}
        const model = this.props.model || {}
        const provider = this.props.provider || offer.provider_info || {}
        const colors = {sell_out: '#d0021b', limited_offer: '#d0021b', new_car: '#d0021b', instant_confirmation: '#218838'}
        return (
            <div className={'cm_card pb-4'} id={`c${offer.id}_${model.id}`}>
                <TooltipWrapper className='r-tooltip' />
                <div className="card">
                    {this.props.book && offer.special &&
                    <div className="card-header p-1" style={{backgroundColor: '#ffffff'}}>
                        <div className="row">
                            <div className="col text-secondary text-center">
                                <span className="red"
                                      style={{fontSize: '1.25rem'}}>{this.props.t.special_offer}{': '}</span>
                                {this.props.t.book_save}
                                <span className="red"
                                      style={{fontSize: '1.25rem'}}>{' '}{offer.special.saved.toFixed(2)}&euro;</span>
                                {offer.special.optionals && offer.special.optionals.length > 0 &&
                                <span>
                                {' '}{this.renderFreeOptionals(offer.special.optionals)}
                                    </span>
                                }
                            </div>
                        </div>
                    </div>}
                    <div className="card-body">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="mb-2">
                                    <h3 className="h5 font-weight-600 d-inline">{model.name}</h3>
                                    <span className="small text-nowrap">{' '}{this.props.t.similar}</span>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        {this.props.toggleGallery &&
                                        <div style={{position: 'relative', display: 'inline-block', cursor: 'pointer'}}
                                             onClick={() => this.props.toggleGallery(model.id)}>
                                            <img src={model.image && model.image[0]} className="img-fluid"/>
                                            <span className="fa fa-search-plus text-white"
                                                  style={{position: 'absolute', bottom: '5px', right: '5px'}}/>
                                        </div>
                                        }
                                        {!this.props.toggleGallery &&
                                        <img src={model.image && model.image[0]} className="img-fluid"/>
                                        }
                                    </div>
                                    <div className="col-6">
                                        <div className="mb-1 small">
                                            <div className="pb-1 mr-3 pl-4 icon-gearbox">{model.gearbox}</div>
                                            <div className="pb-2 pl-4 icon-ac">{this.props.t.air_conditioning}</div>
                                            <div
                                                className="d-inline-block pl-4 mr-3 icon-person">{model.seats}</div>
                                            <div
                                                className="d-inline-block mr-3 pl-4 icon-door">{model.doors}</div>
                                            <div className="d-inline-block mr-3 pl-4 icon-luggage">{model.luggage}</div>
                                        </div>
                                        <div className="row pt-2">
                                            <div className="col-auto pl-2">
                                                <img src={provider.logo} alt={provider.name} title={provider.name} style={{maxWidth: 90, maxHeight: 60}}/>
                                            </div>
                                            {provider.text_rating !== 'hide_rating' &&
                                            <div className="col text-primary text-center" style={{cursor: 'pointer'}}
                                                 onClick={() => provider.reviews > 0 && this.props.showReviews && this.props.showReviews(provider.id)}>
                                                <b>{provider.rating}</b> <span className={'text-nowrap'}>{this.props.t[provider.text_rating]}</span>
                                                {provider.reviews > 0 &&
                                                <div className="small">({provider.reviews} {this.props.t.reviews})</div>}
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6" style={{borderLeft: '1px solid #eeeeee'}}>
                                {offer.badge &&
                                <div className="row mb-1">
                                    <div className="col-6 offset-6 text-center">
                                    <span className="badge badge-danger"
                                          style={{backgroundColor: colors[offer.badge] || '#d0021b'}}>
                                        {this.props.t[offer.badge]}
                                    </span>
                                    </div>
                                </div>}
                                {this.state.fullOffer &&
                                <FullOffer t={this.props.t} offer_id={offer.id} qs={this.props.qs} model_id={model.id} key={`${offer.id}_${model.id}`} 
                                    ext_offer_id={offer.ext_offer_id}/>}
                                <div className="row pt-2">
                                    <div className="col small">
                                        <div
                                            className={'pb-1'}>{this.props.t.full_to_full}{this.renderTooltip('t_full')}
                                        </div>
                                        {provider.limited_km &&
                                        <div className={'pb-1'}>
                                            {this.props.t.l_mileage}{this.renderTooltip('t_l_mileage', {'%{limit}': provider.limited_km})}
                                        </div>
                                        }
                                        {!provider.limited_km &&
                                        <div className={'pb-1'}>
                                            {this.props.t.ul_mileage}{this.renderTooltip('t_mileage')}
                                        </div>
                                        }
                                        {provider.meet_and_greet &&
                                        <div
                                            className={'pb-1'}>{this.props.t.meet_greet}{this.renderTooltip('t_meet')}
                                        </div>
                                        }
                                        {provider.cash &&
                                        <div
                                            className={'pb-1'}>{this.props.t.cash}{this.renderTooltip('t_cash')}
                                        </div>
                                        }
                                        {provider.additional_driver &&
                                        <div
                                            className={'pb-1'}>{this.props.t.additional_driver}{this.renderTooltip('t_additional_driver')}
                                        </div>
                                        }
                                        {!this.props.book &&
                                        <div>
                                            {/* <div
                                                className={'pb-1'}>{this.props.t.c1}{this.renderTooltip('t_c1')}
                                            </div> */}
                                            <div
                                                className={'pb-1'}>{this.props.t.c2}{this.renderTooltip('t_c2')}
                                            </div>
                                            <div
                                                className={'pb-1'}>{this.props.t.c3}{this.renderTooltip('t_c3')}
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    <div className="col-6 text-center">
                                        <div className="text-right">
                                            <div>{this.props.t.price_for} {offer.days} {this.props.t.days}:</div>
                                            {offer.extra_day &&
                                            <div
                                                className={'small text-muted'}>{this.props.t.late_drop} {this.renderTooltip('t_late')}</div>
                                            }
                                            <div className="" style={{minHeight: '1.25rem'}}>
                                                {offer.special &&
                                                <del className="red">{offer.amount.toFixed(2)}&euro;</del>}
                                            </div>
                                            <div className="h3 font-weight-bold">{offer.total.toFixed(2)}&euro;</div>
                                            {(offer.dislocation && +offer.dislocation) > 0 &&
                                            <div className={'text-secondary small'}>{this.props.t.dislocation}{' '}
                                                {offer.dislocation.toFixed(2)}&euro; {this.renderTooltip('t_dislocation')}</div>
                                            }
                                            {(offer.delivery && +offer.delivery) > 0 &&
                                            <div className={'text-secondary small'}>{this.props.t.delivery}{' '}
                                                {offer.delivery.toFixed(2)}&euro; {this.renderTooltip('t_delivery')}</div>
                                            }
                                            {this.props.book && !this.props.change && <div className="my-2">
                                                <a href='#' className={'text-danger'} style={{textDecoration: 'underline'}}
                                                   onClick={(e) => {e.preventDefault();this.setState({fullOffer: !this.state.fullOffer})}}>
                                                    {this.props.t.view_complete_offer}
                                                </a>
                                            </div>}
                                        </div>
                                        {this.props.book &&
                                        <button className={'btn btn-small btn-success w-100 mt-2'}
                                                onClick={() => {
                                                    this.props.setIndex && this.props.setIndex();
                                                    this.props.book({
                                                        offer_id: offer.id,
                                                        model_id: model.id,
                                                        ext_offer_id: offer.ext_offer_id
                                                    })
                                                }}>{this.props.change ? this.props.t.select_car : this.props.t.book}
                                        </button>
                                        }
                                        <div className="small mt-2"
                                             style={{color: '#90f'}}>{this.props.t.includes_fees}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*Anchor for back button */}
                        <div id={`anchor_${(this.props.index || 0) + 1}`}/>
                        <div className={'row'}>
                            <div className={'col mx-3 mt-3'} style={{borderTop: '1px solid #eeeeee'}}>
                                <div className="mb-1 mt-2">{this.props.t.included_price}:</div>
                                <div className={'row small'}>
                                    <div className={'col text-nowrap'}>
                                        <i className={'fa fa-check mr-2 text-success'}/>
                                        {this.props.t.cdw}{this.renderTooltip('t_cdw')}
                                    </div>
                                    {/* <div className={'col text-nowrap'}>
                                        <i className={'fa fa-check mr-2 text-success'}/>
                                        {this.props.t.thw}{this.renderTooltip('t_thw')}
                                    </div> */}
                                    <div className={'col text-nowrap'}>
                                        <i className={'fa fa-check mr-2 text-success'}/>
                                        {this.props.t.tpl}{this.renderTooltip('t_tpl')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}